module.exports = __webpack_public_path__ + "static/media/microsoftGrey.f338f542.svg";